import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CropperDialogComponent } from './cropper-dialog/cropper-dialog.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { base64ToBlob } from '../../functions/base64ToBlob';

@Component({
  selector: 'app-image-control',
  templateUrl: './image-control.component.html'
})
export class ImageControlComponent implements OnInit {

  @Input() ratio = 1 / 1;
  @Input() src!: any;
  @Output() imageReady = new EventEmitter<{ blob: Blob, src: string }>();

  @Input() maxSize = 2;
  fileErrors = {
    type: false,
    size: false
  };
  @Output() errors = new EventEmitter<any>();

  constructor(
    public dialog: MatDialog,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
  }

  fileSelected(event: any) {
    const file = event.target?.files[0];
    if (file && this.validateFile(file)) {
      const dialogRef = this.dialog.open(CropperDialogComponent, {
        data: { image: file, ratio: this.ratio },
        width: '600px',
      });
      dialogRef.afterClosed().subscribe((result: ImageCroppedEvent) => {
        console.log(result);

        if (result && result.base64) {
          this.src =
            this.sanitizer.bypassSecurityTrustUrl(result.base64);
          let file: any = base64ToBlob(result.base64); //result.blob;
          
          file.name = 'image.png';
          this.imageReady.emit({ blob: file, src: this.src });
        }
      });
    }
    this.errors.emit(this.fileErrors);
  }

  validateFile(file: File): any {
    if (this.fileType(file.name)) {
      this.fileErrors.type = false;
      if ((file.size / (1024 * 1024)) <= this.maxSize) {
        this.fileErrors.size = false;
      } else {
        this.fileErrors.size = true;
        return false;
      }
    } else {
      this.fileErrors.type = true;
      return false;
    }
    return true;
  }
  fileType(fileName: string): any {
    const extension = fileName.split('.')?.pop()?.toLowerCase();
    switch (extension) {
      case 'jpeg':
      case 'jpg':
        return 'jpg';
      case 'png':
        return 'png';
      default:
        return false;
    }
  }
}
